/*
 * @providesModule MaintenancePopupWrapper
 */

import React from 'react';
import MaintenancePopup from 'MaintenancePopup';
import {useMaintenance} from 'useMaintenance';

const MaintenancePopupWrapper = () => {
  const {isMaintenanceActive, heading, subheading} = useMaintenance();

  return (
    <MaintenancePopup
      isVisible={isMaintenanceActive}
      heading={heading}
      subheading={subheading}
    />
  );
};

export default MaintenancePopupWrapper;
